import {useAllSectors} from "crqlar-react-common/dist/utils/hooks/sectors/useSectors";
import {useTranslation} from "react-i18next";
import {useIsFetching} from "react-query";
import NodeMultiSelectField, {NodeMultiSelectOption} from "../../marketing/automations/components/v2/fields/NodeMultiSelectField";
import {sectorTypeLabel} from "../../marketing/automations/components/v2/triggers/SectorMultiSelectField";

interface Props {
    value: string[]
    onChange: (sectorIds: string[]) => void
    disabled?: boolean
}

/** Multi-select field for scoping signing templates to specific sectors. */
const DigitalSigningOfferField = ({value, onChange, disabled}: Props) => {
    const {t} = useTranslation();
    const sectors = useAllSectors();
    const loading = useIsFetching('allSectors') > 0;
    // A single "Other" heading over every sector is noise, so the list stays flat without types
    const anyTyped = sectors.some(sector => !!sector.sectorType);

    const options: NodeMultiSelectOption[] = sectors
        .filter(sector => !!sector.id && (!sector.archived || value.includes(sector.id)))
        .map(sector => ({
            value: sector.id!,
            label: sector.name || '',
            group: anyTyped ? sectorTypeLabel(sector.sectorType, t) : undefined,
        }));

    return (
        <NodeMultiSelectField
            label={''}
            placeholder={t('No sector')}
            value={value}
            options={options}
            loading={loading}
            onChange={onChange}
            disabled={disabled}
        />
    );
};

export default DigitalSigningOfferField;
